import ReactDOM from 'react-dom'

import { Loading } from '@interco/inter-ui/components/Loading'

import App from './App'
import useBoundState from './store'
import NewRelicUtils from './config/monitoring/NewRelicUtils'

import './App.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

const renderBootstrapLoading = () => {
  ReactDOM.render(
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
      }}
    >
      <Loading
        width={56}
        height={56}
        color="var(--static-orange-500)"
        dataTestId="bootstrap-loading"
      />
    </div>,
    rootElement,
  )
}

const renderApp = () => {
  ReactDOM.render(<App />, rootElement)
}

const bootstrap = async () => {
  renderBootstrapLoading()

  try {
    await useBoundState.getState().getContentManager()
  } catch (error) {
    NewRelicUtils.noticeError(error as Error, {
      errorCodeRef: 'bootstrap/getContentManager',
    })
  } finally {
    renderApp()
  }
}

bootstrap()
